<!-- @media Screen collapsed -->
<div *ngIf="hasContent" class="d-print-none" [ngClass]="{'d-none': expandContent}">
    <div class="card card-cascade card-wider">
        <div class="card-header secondary-color lighten-1 white-text" (click)="expandContent = !expandContent">
            <span class="fa fa-hand-o-right"></span>
            What does this mean?
        </div>
    </div>
</div>
<!-- @media Screen expanded -->
<div *ngIf="hasContent" [ngClass]="{'d-none': !expandContent}" class="d-print-none">
  <div class="card card-cascade card-wider">
    <div class="card-header secondary-color lighten-1 white-text" (click)="expandContent = !expandContent">
        <span class="fa fa-hand-o-up"></span>
        What does this mean?
    </div>
    <div class="card-body">
      <div *ngIf="shouldShowContent(scaleResult)" [innerHTML]="scaleResult?.range?.therapistContent"></div>
    </div>
    <div class="card-footer text-muted secondary-color white-text" (click)="expandContent = !expandContent">
        <span class="fa fa-hand-o-up"></span>
        What does this mean?
    </div>
  </div>
</div>
<!-- @media Print only shows if notes enabled -->
<div *ngIf="hasContent" class="therapist-note-print-content" >
  <div class="card card-cascade card-wider">
    <div class="card-header secondary-color lighten-1 white-text" (click)="expandContent = !expandContent">
        <span class="fa fa-hand-o-right"></span>
        What does this mean? 
    </div>
    <div class="card-body">
      <div [innerHTML]="scaleResult?.range?.therapistContent"></div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/scale-range-content/scale-range-content.component.html